import { InspectionStatusType, InspectionStatusTypeOptions } from '@apply/constants';
import { CellRenderEvent } from '../../interfaces/interfaces';

export const onStatusRender = (e: CellRenderEvent): React.ReactNode => {
    const status = InspectionStatusTypeOptions.find((s) => s.id === e.value);
    if (!status) {
        return 'Unknown Status';
    }
    if (e.value === InspectionStatusType.Error) {
        return <span style={{ color: 'red' }}>{status.name}</span>;
    } else if (e.value === InspectionStatusType.InspectionDelivered) {
        return <span style={{ color: 'green' }}>{status.name}</span>;
    }
    return status.name;
};
